import { SearchFilterTag } from '@/components';
import { AdministrativeReformTeamEvaluationOptionLabelModifier } from '@/features/project/_models/project-filter';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { isPS } from '@/utils';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export const SkipAdministrativeReformTeamEvaluationTag: FC = () => {
  const { control, setValue } = useFormContext<ProjectSearchFormType>();

  const sheetType = useWatch({
    control,
    name: 'sheetType',
  });
  const skipAdministrativeReformTeamEvaluation = useWatch({
    control,
    name: 'skipAdministrativeReformTeamEvaluation',
  });

  if (sheetType !== 'RS' || isPS() || !skipAdministrativeReformTeamEvaluation) {
    return null;
  }

  return (
    <SearchFilterTag
      closable={true}
      label={
        AdministrativeReformTeamEvaluationOptionLabelModifier[
          skipAdministrativeReformTeamEvaluation
        ]
      }
      onClose={() => {
        setValue('skipAdministrativeReformTeamEvaluation', null);
      }}
    />
  );
};
